<template>
<div class="container bg-white borda" style="margin-top: 30px; padding: 0px; max-width: 1185px;">
  <form class="p-3" style>
    <!-- 2ª Etapa Não Contribuinte -->
    <div class="mt-3">
      <b-row>
        <b-col md="12">
          <router-link style="font-size: 14px;" to="/difal" class="btn btn-primary" tag="button">
            <i class="fas fa-backward mr-2"></i>Voltar
          </router-link>
          <p class="referencia" style="font-size: 28px;"> Contribuinte <span class="desc-fed" v-if="objetoReceber.destino == 'DF'">- <a target="_blank" rel="noopener noreferrer" href="https://www.lefisc.com.br/regulamento/69/773/">Verifique a lista dos produtos sujeitos a antecipação tributária</a></span></p>
        </b-col>
      </b-row>
      <b-row>
        <b-col md="6" class="text-left">
          <label for="uforigem">UF Origem:</label>
          <b-form-select
            class="select"
            name="uforigem"
            ref="reforigem"
            id="uforigem"
            v-model="objetoReceber.origem"
            :options="options"
            :value="options.Sigla"
          ></b-form-select>
          <span class="erro" v-if="validacao.origem">* Preenchimento Obrigatório, escolha um UF</span>
        </b-col>
        <b-col md="6" class="text-left">
          <label for="uforigem">UF Destino:</label>
          <b-form-input
            name="ufdestino"
            ref="refdestino"
            id="ufdestino"
            v-model="estado"
            :options="options"
            :value="objetoReceber.destino"
            disabled
          ></b-form-input>
          <span class="erro" v-if="validacao.destino">* Preenchimento Obrigatório, escolha um UF</span>
        </b-col>
        
        <b-col md="6" class="text-left mt-3" v-if="objetoReceber.destino === 'BA'">
          <label for="simplesNacional">Destinatário optante pelo Simples Nacional:</label>
          <b-form-radio-group
          id="simplesNacional"
          v-model="objetoReceber.simplesNacional"
          :options="[
            { text: 'Sim', value: true },
            { text: 'Não', value: false }
          ]"
          name="simplesNacional"
          ></b-form-radio-group>
        </b-col>
      </b-row>
      <br>
      <b-col md="6" v-if="objetoReceber.destino == 'DF' && $route.params.finalidade != 1">
        <div>
          <div><!--v-if="this.$route.params.ID != 13"-->
          <h6 class="subtitulo">Tipo de cálculo</h6>
            <div><!--PrecoMedio-->
              <b-form-radio
                v-model="tipoDeCalculoDF"
                name="tipoDeCalculoDF"
                :value="1"
                :disabled="desabilitaIcmAlgumasRegioes()"
              >Preço médio</b-form-radio>                    
              <b-form-radio
                v-model="tipoDeCalculoDF"
                name="tipoDeCalculoDF"
                :value="2"
                :disabled="desabilitaIcmAlgumasRegioes()"
              >Cálculo com margem</b-form-radio>
            </div>
          </div>
        </div>
      </b-col>
      <b-row class="my-3" >
        <b-col v-bind:md="objetoReceber.destino == 'DF' ? '6' : '12' &&   $route.params.finalidade != 1" class="text-left">
          <label for="valoroperacao">Valor   {{alterarNomeProduto}}</label>
        </b-col>
        <b-col md="6" v-if="objetoReceber.destino == 'DF' && tipoDeCalculoDF == 1 && $route.params.finalidade != 1" class="text-left">
          <label for="precoMedio">Preço Médio</label>
        </b-col>
        <b-col md="6" v-if="objetoReceber.destino == 'DF' && tipoDeCalculoDF == 2 && $route.params.finalidade != 1" class="text-left">
          <label for="ipiInput">IPI</label>
        </b-col>    
        <b-col v-bind:md="objetoReceber.destino == 'DF' &&  $route.params.finalidade != 1  ? '6' : '12' " >
          
          <b-input-group 
            type="text"
            @mouseover="hovertooltip = true"
            @mouseleave="hovertooltip = false"
            prepend="R$"
          >
          
            <input 
              name="valoroperacao"
              ref="refvaloroperacao"
              v-money="money"
              id="valoroperacao"
              type="text"
              class="form-control"
              v-model="objetoReceber.valorOperacao"
            />
          </b-input-group>
          <span class="erro" v-if="validacao.valorOperacao">* Preenchimento Obrigatório</span>
        </b-col>
        <b-col  v-bind:md="objetoReceber.destino == 'DF' &&  $route.params.finalidade != 1 ? '6' : '12' "  v-if="objetoReceber.destino == 'DF' && tipoDeCalculoDF == 1 &&  $route.params.finalidade != 1">
          <b-input-group
            type="text"
            @mouseover="hovertooltip = true"
            @mouseleave="hovertooltip = false"
            prepend="R$"
          >
            <input
              name="precoMedio"
              ref="refprecoMedio"
              v-money="money"
              id="precoMedio"
              type="text"
              class="form-control"
              v-model="objetoReceber.precoMedio"
            />
          </b-input-group>
          <span class="erro" v-if="validacao.valorOperacao">* Preenchimento Obrigatório</span>
        </b-col>
        <b-col md="6" v-if="objetoReceber.destino == 'DF' && tipoDeCalculoDF == 2">
          <b-input-group
            type="text"
            @mouseover="hovertooltip = true"
            @mouseleave="hovertooltip = false"
            prepend="R$"
          >
            <input
              name="ipiInput"
              ref="refipiInput"
              v-money="money"
              id="ipiInput"
              type="text"
              class="form-control"
              v-model="objetoReceber.ipi"
            />
          </b-input-group>
          <!-- <span class="erro" v-if="validacao.valorOperacao">* Preenchimento Obrigatório</span> -->
        </b-col>
      </b-row>
      <b-row class="my-3" v-if="tipoDeCalculoDF == 2 || tipoDeCalculoDF == 0">
        <b-col md="6" class="text-left">
          <label for="frete">Frete:</label>
          <b-input-group type="text" prepend="R$">
            <input
              name="frete"
              id="frete"
              ref="reffrete"
              type="text"
              v-money="money"
              class="form-control"
              v-model="objetoReceber.frete"
            />
          </b-input-group>
          <span class="erro" v-if="validacao.frete">* Campo Inválido</span>
        </b-col>
        <b-col md="6" v-if="tipoDeCalculoDF == 2 || tipoDeCalculoDF == 0">
          <label for="despesasacessorias">Despesas Acessórias:</label>
          <b-input-group type="text" prepend="R$">
            <input
              type="text"
              v-money="money"
              ref="refdespesasacessorias"
              name="despesasacessorias"
              id="despesasacessorias"
              class="form-control"
              v-model="objetoReceber.despesasAcessorias"
            />
          </b-input-group>
          <span class="erro" v-if="validacao.despesasAcessorias">* Campo Inválido</span>
          
        </b-col>
      </b-row> 

       <!-- Campo Novo Acre Anexo V -->    
       <b-row class="my-3" v-if="this.$route.params.ID == 1 && this.$route.params.finalidade !=1 && this.$route.params.anexo == 5">
        <b-col md="6" class="text-left">
          <label for="frete">Alíquota Interna ICMS:</label> <span style="font-size:15px"><a href="https://www.lefisc.com.br/ncm/" target="_blank">Consultar</a></span>
             <b-form-select
            class="select"               
            v-model="objetoReceber.AliquotaInterna "
            :options="[ { ID:'1',value: '17','text': '17%','visivel':true,'checked':true }]"
            :value="optionsAcre.value"
          ></b-form-select>
         <span class="erro" v-if="validacao.AliquotaInterna">* Preenchimento Obrigatório</span>
        </b-col>
        <b-col md="6">
           <label ><strong>Produtos</strong></label>
           <div>
          <b-form-radio sele
                        v-model="selectAnexoV" 
                          value="1"                          
                         @click="objetoReceber.produtos = 1"                     
                      >Anexo I - Convênio ICMS 52/91</b-form-radio>                    
                      <b-form-radio
                        v-model="selectAnexoV" 
                          value="2"                        
                        @click="objetoReceber.produtos = 2"                        
                      > Anexo II - Convênio ICMS 52/91</b-form-radio>
                      </div> 
        </b-col>
      </b-row>
       <!-- Fim Campo Novo Acre V--> 

      <!-- Campo Novo Acre Anexo IV -->    
       <b-row class="my-3" v-if="this.$route.params.ID == 1 && this.$route.params.finalidade !=1 && this.$route.params.anexo == 4">
        <b-col md="6" class="text-left">
          <label for="frete">Alíquota Interna ICMS:</label> <span style="font-size:15px"><a href="https://www.lefisc.com.br/ncm/" target="_blank">Consultar</a></span>
             <b-form-select
            class="select"    
            v-model="objetoReceber.AliquotaInterna"
            :options="optionsAcre"
            :value="optionsAcre.value"
          ></b-form-select>
         <span class="erro" v-if="validacao.AliquotaInterna">* Preenchimento Obrigatório</span>
        </b-col>
        <b-col md="6">
           <label ><strong>Procedência</strong></label>
           <div>
         <b-form-checkbox
                        v-model="objetoReceber.frango"                      
                        @click="objetoReceber.frango = !objetoReceber.frango"                     
                      >Frango ou galinha não cortados em pedaços, frescos ou congelados, temperados ou não, adquiridos por bares, restaurantes e similares (insumos)</b-form-checkbox>                    
                     
                      </div>       
        </b-col>
      </b-row>
      <!-- Fim Campo Novo Acre IV--> 

      <!-- Campo Novo Acre  II-->   
      <b-row class="my-3" v-if="this.$route.params.ID == 1 && this.$route.params.finalidade !=1 && this.$route.params.anexo == 2 ">
        <b-col md="6" class="text-left">
          <label for="frete">Alíquota Interna ICMS:</label> <span style="font-size:15px"><a href="https://www.lefisc.com.br/ncm/" target="_blank">Consultar</a></span>
             <b-form-select
            class="select"    
            v-model="objetoReceber.AliquotaInterna"
            :options="optionsAcre"
            :value="optionsAcre.value"
          ></b-form-select>
         <span class="erro" v-if="validacao.AliquotaInterna">* Preenchimento Obrigatório</span>
        </b-col>
        <b-col md="6">
           <label ><strong>Situação</strong></label>
           <div>
         <b-form-radio
                        v-model="objetoReceber.inadimplente"                      
                        :value="true"                       
                      >Contribuinte Inadimplente</b-form-radio>                    
                      <b-form-radio
                        v-model="objetoReceber.inadimplente"                        
                        :value="false"                        
                      > Estabelecimento em situação fiscal regular</b-form-radio>
                      </div>
          <span class="erro" v-if="validacao.inadimplenteAcre">* Preenchimento Obrigatório</span>
        </b-col>
      </b-row>
      <!-- Fim Campo Novo Acre II-->
      <b-row class="my-3" v-if="this.$route.params.ID != 1  || this.$route.params.finalidade == 1 ||  this.$route.params.anexo == 3">
        <b-col v-bind:md="objetoReceber.destino == 'DF' && tipoDeCalculoDF == 2 ? '6' : '12'" class="text-left">
          <label for="aliquotainterna">Alíquota Interna ICMS: 
            <span style="font-size:15px" v-if="this.$route.params.ID == 24 && this.$route.params.finalidade == 3 && this.$route.params.importado == 2 && this.$route.params.destinatario ==1">
              <a href="https://www.lefisc.com.br/regulamento/38/61/#art00060" target="_blank">Verificar regras do artigo 60, Parágrafo 37 do RICMS/SC</a>
            </span>
            <span style="font-size:15px" v-else>
              <a href="https://www.lefisc.com.br/ncm/" target="_blank">Consultar</a>
            </span>
          </label>
        </b-col>
        <b-col md="6" v-if="objetoReceber.destino == 'DF' && tipoDeCalculoDF == 2" class="text-left">
          <label for="margemInput">Margem: <a href="https://www.lefisc.com.br/regulamento/69/772/" target="_blank" rel="noopener noreferrer">Consute a lista de MVAs</a></label>
        </b-col>
        <b-col v-bind:md="objetoReceber.destino == 'DF' && tipoDeCalculoDF == 2 ? '6' : '12'">
          <b-input-group type="number" append="%">
            <input
            :readonly="$route.params.anexo == 3"
              name="aliquotainterna"
              min="0"
              ref="refaliquotainterna"
              v-money="porcentagemAliquota"
              maxlength="5"
              type="text"
              id="aliquotainterna"
              class="form-control"
              v-model="objetoReceber.AliquotaInterna"
            />
          </b-input-group>
          <span class="erro" v-if="validacao.AliquotaInterna">* Preenchimento Obrigatório</span>
        </b-col>
        <b-col v-if="objetoReceber.destino == 'DF' && tipoDeCalculoDF == 2" v-bind:md="objetoReceber.destino == 'DF' && tipoDeCalculoDF == 2 ? '6' : '12'">
          <b-input-group
            type="text"
            @mouseover="hovertooltip = true"
            @mouseleave="hovertooltip = false"
            prepend="R$"
          >
            <input
              name="margemInput"
              ref="refmargemInput"
              v-money="money"
              id="margemInput"
              type="text"
              class="form-control"
              v-model="objetoReceber.margem"
            />
          </b-input-group>
          <span class="erro" v-if="validacao.valorOperacao">* Preenchimento Obrigatório</span>
        </b-col>
      </b-row>
      
      <div v-if="this.$route.params.ID == 9">
      <b-row class="my-3">
          <b-col md="12" class="text-left">
            <label for="aliquotainterna">Mva : <a href="https://www.lefisc.com.br/open.aspx?id=1&cod=178672">Decreto 6.716 - 2008</a></label>
          </b-col>
          <b-col md="12">
            <b-input-group type="number" append="%">
              <input
                name="mva"
                min="0"
                ref="mva"
                v-money="porcentagem2"
                maxlength="5"
                type="text"
                id="mva"
                class="form-control"
                v-model="objetoReceber.mva"
              />
            </b-input-group>            
          </b-col>
        </b-row>
        </div>
      <b-row class="my-3">
        <b-col md="6" class="text-left">
          <label for="reducaobaseinterna">Redução da base interna:</label>
          <b-input-group type="number" append="%">
            <input
              type="text"
              id="reducaobaseinterna"
              min="0"
              v-money="porcentagem2"
              maxlength="5"
              class="form-control"
              v-model="objetoReceber.ReInterna"
            />
          </b-input-group>
          <span class="erro" v-if="validacao.ReInterna">* Campo Inválido</span>
        </b-col>
        <b-col md="6">
          <label for="reducaobaseexterna">Redução da base interestadual:</label>
          <b-input-group type="number" append="%">
            <input
              type="text"
              id="reducaobaseexterna"
              min="0"
              v-money="porcentagem2"
              maxlength="5"
              class="form-control"
              v-model="objetoReceber.ReInterestadual"
            />
          </b-input-group>
          <span class="erro" v-if="validacao.ReInterestadual">* Campo Inválido</span>
        </b-col>
      </b-row>
      <b-row class="my-3">
        <b-col class="text-left">
          <b-form-group>
            <b-row>
              <b-col md="6">
                <div>
                  <div v-if="this.$route.params.ID != 13">
                  <h6 class="subtitulo">ICMS</h6>
                  <div>
                      <b-form-radio
                        v-model="objetoReceber.icms"
                        name="IcmsBool"
                        :value="true"
                        :disabled="desabilitaIcmAlgumasRegioes()"
                      >Com ICMS na base</b-form-radio>                    
                      <b-form-radio
                        v-model="objetoReceber.icms"
                        name="IcmsBool"
                        :value="false"
                        :disabled="desabilitaIcmAlgumasRegioes()"
                      >Sem ICMS na base</b-form-radio>
                  </div>
                  </div>
                </div>
              </b-col>
              <b-col md="6">
                <div>
                  <h6 class="subtitulo">ORIGEM DA MERCADORIA</h6>
                  <div class="custom-control custom-radio">
                    <input
                      type="radio"
                      id="nacional"
                      @click="objetoReceber.Importada = false"
                      name="origemMercadoria"
                      class="custom-control-input"
                      :checked="importadoTrue"
                      disabled
                    />
                    <label class="custom-control-label" for="nacional">Nacional</label>
                  </div>
                  <div class="custom-control custom-radio">
                    <input
                      type="radio"
                      id="importadaouCIS40"
                      @click="objetoReceber.Importada = true"
                      name="origemMercadoria"
                      class="custom-control-input"
                      :checked="importadoFalse"
                      disabled
                    />
                    <label
                      class="custom-control-label"
                      for="importadaouCIS40"
                    >Importada ou com conteúdo de importação superior a 40%</label>
                  </div>
                </div>
              </b-col>
            </b-row>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row v-if="objetoReceber.destino == 'PB' && objetoReceber.icms">
        <b-col md="6">
          <div style="display: flex; align-items: center;">
            <b-form-checkbox
              v-model="tipoDeCalculoPB"
              name="tipoDeCalculoPB"
              id="tipoDeCalculoPB"
            ></b-form-checkbox>
            <label for="tipoDeCalculoPB">Remetente Optante pelo Simples Nacional (Cálculo Conforme Anexo Único Portaria 43/2021)</label>  
          </div>
        </b-col>
        <b-col md="6" v-if="tipoDeCalculoPB">
          <div>
            <div>
            <label for="valorCreditoPB">Valor Permissão de Crédito</label>
            <b-input-group
              type="text"
              @mouseover="hovertooltip = true"
              @mouseleave="hovertooltip = false"
              prepend="R$"
            >
              <input
                name="valorCreditoPB"
                ref="refvalorCreditoPB"
                v-money="money"
                id="valorCreditoPB"
                type="text"
                class="form-control"
                v-model="valorSN"
              />
            </b-input-group>
            </div>
          </div>
        </b-col>
      </b-row>
      <b-row>
        <b-col class="text-right">
          <button
           style="font-size: 14px;"
            class="btn btn-danger"
            v-if="reiniciarBool"
            @click.prevent.stop="reiniciar()"
          >Limpar campos</button>
          <button style="font-size: 14px;" class="btn btn-success" @click.prevent.stop="loading = true, enviar()">
            {{ botaoTitulo }}
            <div class="spinner-border text-white loading" v-if="loading" role="status">
              <span class="sr-only">Aguarde...</span>
            </div>
          </button>
        </b-col>
      </b-row>

      <!-- Modal Resultado -->
      <b-modal ref="resultadoID" centered ok-only v-b-modal.modal-sm class="text-center" size="lg">
        <div class="spinner-border text-primary" v-if="loading" role="status">
          <span class="sr-only">Aguarde...</span>
        </div>
        
        <!-- Resultado Simples (quando não há detalhes) -->
        <div v-if="resultado && !resultadoDetalhes">
          <h3 class="tituloModal d-inline">
            <span v-if="exibirNum"> Diferencial de Alíquotas: </span>
            <div v-if="!exibirNum">
              <span v-html="resultado" style="font-weight: 600;"></span>
            </div>
            <input v-if="exibirNum" v-money="money2" :value="resultado" class="w-25 ml-3 resultadoInput" />
          </h3>
        </div>

        <!-- Resultado Detalhado (quando há detalhes) -->
        <div v-if="resultadoDetalhes" class="resultado-detalhado">
          <h4 class="mb-4 font-weight-bold">Informações para o cálculo</h4>
          <b-row class="mb-3 info-row">
            <b-col cols="8" class="text-left label-campo">
              Valor da Operação/Valor total da Nota Fiscal 
              <i class="fas fa-info-circle text-primary" v-b-tooltip.hover title="Valor total da operação"></i>
            </b-col>
            <b-col cols="4" class="text-right valor-campo">
              {{ formatarMoeda(resultadoDetalhes.detalhes.valorOperacaoTotal) }}
            </b-col>
          </b-row>

          <h4 class="mb-3 mt-4 font-weight-bold">Cálculo</h4>
          <b-row class="mb-2 info-row">
            <b-col cols="8" class="text-left label-campo">
              Valor da operação origem (com o ICMS embutido)
            </b-col>
            <b-col cols="4" class="text-right valor-campo">
              {{ formatarMoeda(resultadoDetalhes.detalhes.valorOperacaoOrigemComIcms) }}
            </b-col>
          </b-row>
          <b-row class="mb-2 info-row">
            <b-col cols="8" class="text-left label-campo">
              Alíquota de ICMS Interestadual origem
            </b-col>
            <b-col cols="4" class="text-right valor-campo">
              {{ formatarPorcentagem(resultadoDetalhes.detalhes.aliquotaInterestadual) }}
            </b-col>
          </b-row>
          <b-row class="mb-2 info-row">
            <b-col cols="8" class="text-left label-campo">
              Alíquota ou carga tributária de ICMS - Interna Destino
            </b-col>
            <b-col cols="4" class="text-right valor-campo">
              {{ formatarPorcentagem(resultadoDetalhes.detalhes.aliquotaInternaDestino) }}
            </b-col>
          </b-row>
          <b-row class="mb-3 info-row">
            <b-col cols="8" class="text-left label-campo">
              Percentual de Fundo de Combate a Pobreza
            </b-col>
            <b-col cols="4" class="text-right valor-campo">
              {{ formatarPorcentagem(resultadoDetalhes.detalhes.percentualFundoCombatePobreza) }}
            </b-col>
          </b-row>

          <h4 class="mb-3 mt-4 font-weight-bold">ICMS Total UF Origem</h4>
          <b-row class="mb-2 info-row">
            <b-col cols="8" class="text-left label-campo">
              Base de cálculo da operação origem (Com o ICMS)
            </b-col>
            <b-col cols="4" class="text-right valor-campo">
              {{ formatarMoeda(resultadoDetalhes.detalhes.baseCalculoOperacaoOrigemComIcms) }}
            </b-col>
          </b-row>
          <b-row class="mb-2 info-row">
            <b-col cols="8" class="text-left label-campo">
              Alíquota de ICMS Interestadual origem
            </b-col>
            <b-col cols="4" class="text-right valor-campo">
              {{ formatarPorcentagem(resultadoDetalhes.detalhes.aliquotaInterestadual) }}
            </b-col>
          </b-row>
          <b-row class="mb-3 info-row">
            <b-col cols="8" class="text-left label-campo">
              Valor do ICMS origem
            </b-col>
            <b-col cols="4" class="text-right valor-campo">
              {{ formatarMoeda(resultadoDetalhes.detalhes.valorIcmsOrigem) }}
            </b-col>
          </b-row>

          <h4 class="mb-3 mt-4 font-weight-bold">ICMS Total UF Destino</h4>
          <b-row class="mb-2 info-row">
            <b-col cols="8" class="text-left label-campo">
              Base de Cálculo do ICMS Diferencial de alíquota
            </b-col>
            <b-col cols="4" class="text-right valor-campo">
              {{ formatarMoeda(resultadoDetalhes.detalhes.baseCalculoIcmsDestino) }}
            </b-col>
          </b-row>
          <b-row class="mb-2 info-row">
            <b-col cols="8" class="text-left label-campo">
              Alíquota ou carga tributária de ICMS - Interna Destino
            </b-col>
            <b-col cols="4" class="text-right valor-campo">
              {{ formatarPorcentagem(resultadoDetalhes.detalhes.aliquotaInternaDestino) }}
            </b-col>
          </b-row>
          <b-row class="mb-3 info-row">
            <b-col cols="8" class="text-left label-campo">
              Valor do ICMS Total
            </b-col>
            <b-col cols="4" class="text-right valor-campo">
              {{ formatarMoeda(resultadoDetalhes.detalhes.valorIcmsTotalDestino) }}
            </b-col>
          </b-row>

          <h4 class="mb-3 mt-4 font-weight-bold">Totais</h4>
          <b-row class="mb-2 info-row destaque">
            <b-col cols="8" class="text-left label-campo font-weight-bold">
              Valor do Difal
            </b-col>
            <b-col cols="4" class="text-right valor-campo font-weight-bold">
              {{ formatarMoeda(resultadoDetalhes.valor) }}
            </b-col>
          </b-row>
          <b-row class="mb-2 info-row" v-if="resultadoDetalhes.detalhes.fundoCombatePobrezaAplicavel">
            <b-col cols="8" class="text-left label-campo">
              Valor do Difal (Fundo de Combate a Pobreza )
            </b-col>
            <b-col cols="4" class="text-right valor-campo">
              {{ formatarMoeda(resultadoDetalhes.valorFundoCombatePobreza) }}
            </b-col>
          </b-row>
        </div>
      </b-modal>
      <!-- Modal Resultado FIM -->
    </div>
    <!-- 2ª Etapa Não Contribuinte FIM -->
  </form>
</div>
</template>

<script>
import estados from "../assets/arquivos/estados.json";
import aliq_acre from "../assets/arquivos/aliq_acre.json";
import Aliquota from "../models/Aliquotas.js";
import serviceAliquotas from "../services/serviceAliquotas.js";
import { VMoney } from "v-money";

export default {
  directives: { money: VMoney },

  data() {
    return {
      mostraDecreto:false,
      tipoDeCalculoDF: 0,
      tipoDeCalculoPB: false,
      valorSN: "0",
      options: estados,
      selectAnexoV:1,
      optionsAcre:aliq_acre,
      optionsDestino: estados,
      objetoEnviar: new Aliquota(),
      objetoReceber: new Aliquota(),
      resultado: 0,
      resultadoDetalhes: null,
      exibirResultadoRS:false,
      importadoTrue: false,
      importadoFalse: false,
      botaoTitulo: "Calcular",
      reiniciarBool: false,
      loading: false,
      hovertooltip: false,
      adquirente: null,
      destinatario: null,
      estado: "",

      validacao: {
        aliquotaInternaAcre:false,
        inadimplenteAcre:false,
        origem: false,
        destino: false,
        destinoOrigem: false,
        valorOperacao: false,
        frete: false,
        despesasAcessorias: false,
        AliquotaInterna: false,
        ReInterna: false,
        ReInterestadual: false,
        importada: false,
        icms: false
      },

      validacaoAdquirente: {
        adquirente: false,
        destinatario: false,
        finalidadeAquisicao: false,
        origemMercadoria: false,
        camposvalidos: false
      },

      money: {
        decimal: ",",
        thousands: ".",
        prefix: "",
        suffix: "",
        precision: 2,
        masked: false /* doesn't work with directive */
      },

      money2: {
        decimal: ",",
        thousands: ".",
        prefix: "R$ ",
        suffix: "",
        precision: 2,
        masked: false /* doesn't work with directive */
      },

      porcentagem: {
        decimal: "",
        thousands: "",
        prefix: "",
        suffix: "",
        precision: 0,
        masked: false /* doesn't work with directive */
      },
     porcentagemAliquota: {
        decimal: ".",
        thousands: "",
        prefix: "",
        suffix: "",
        precision: 2,
        masked: false /* doesn't work with directive */
      },
      porcentagem2: {
        decimal: ".",
        thousands: "",
        prefix: "",
        suffix: "",
        precision: 2,
        masked: false /* doesn't work with directive */
      },
    exibirNum:true,
      camposvalidos: 0,

      service: null
    };
  },

  created() {
    this.objetoEnviar = new Aliquota();
    this.objetoReceber = new Aliquota();
    this.objetoReceber.destino = this.ufDestino;
    this.sigla = this.$route.params.sigla;

    if (this.$route.params.importado == "1") {
      this.objetoReceber.importada = false;
      this.importadoTrue = true;
    } else {
      this.objetoReceber.importada = true;
      this.importadoFalse = true;
    }

    this.options.forEach(estado => {
      if (estado.ID == this.$route.params.ID) {
        // achou!
        this.estado = estado.text;
        this.objetoReceber.destino = estado.value;
        return;
      }
    });

    this.service = serviceAliquotas;
  },
  methods: {
    desabilitaIcmAlgumasRegioes(){
      if(this.$route.params.ID ==9 || this.$route.params.ID ==3 || this.$route.params.ID ==4 || this.$route.params.ID ==1 || this.$route.params.ID == 22){
        if(this.$route.params.finalidade != 1){
          return true;
        }
      }
      return false;
    },
    enviar() { 
      this.objetoEnviar.simplesNacional = this.objetoReceber.simplesNacional;
      console.log('Enviando para backend:', this.objetoEnviar.simplesNacional);
      this.objetoEnviar.inadimplente =this.objetoReceber.inadimplente
      this.objetoEnviar.origem = this.objetoReceber.origem;
      this.objetoEnviar.destino = this.objetoReceber.destino;
      this.objetoEnviar.valorOperacao = this.objetoReceber.valorOperacao;
      console.log(this.objetoEnviar.valorOperacao)
      this.objetoEnviar.frete = this.objetoReceber.frete;
      this.objetoEnviar.despesasAcessorias = this.objetoReceber.despesasAcessorias;
      this.objetoEnviar.AliquotaInterna = this.objetoReceber.AliquotaInterna;
      this.objetoEnviar.reducaoDeBaseInterna = this.objetoReceber.ReInterna;
      this.objetoEnviar.reducaoDeBaseExterna = this.objetoReceber.ReInterestadual;
      this.objetoEnviar.ReInterna = this.objetoReceber.ReInterna;
      this.objetoEnviar.ReInterestadual = this.objetoReceber.ReInterestadual
      
      this.objetoEnviar.importada = this.objetoReceber.importada;
      this.objetoEnviar.mva = this.objetoReceber.mva;
      this.objetoEnviar.destinatario = this.$route.params.destinatario;    
      this.objetoEnviar.codigoProduto = this.$route.params.produtoAcre;
      this.objetoEnviar.frango = this.objetoReceber.frango
      this.objetoEnviar.finalidade = parseInt(this.$route.params.finalidade)
      this.objetoEnviar.ipi = parseFloat(((this.objetoReceber.ipi.toString()).replaceAll('.','')).replace(',','.'))
      this.objetoEnviar.margem = parseFloat(((this.objetoReceber.margem.toString()).replaceAll('.','')).replace(',','.'))
      this.objetoEnviar.isPrecoMedio = this.tipoDeCalculoDF == 1 ? true : false
      this.objetoEnviar.remetenteSN = this.tipoDeCalculoPB
      this.objetoEnviar.valorSN = parseFloat(((this.valorSN.toString()).replaceAll('.','')).replace(',','.'))
      this.objetoEnviar.PrecoMedio = parseFloat(((this.objetoReceber.precoMedio.toString()).replaceAll('.','')).replace(',','.'))
   
      if(this.$route.params.ID == 13){
        this.objetoEnviar.icms = true;
      }else{
        this.objetoEnviar.icms = this.objetoReceber.icms;
      }
      this.resultado = 0;  
      console.log(this.inadimplenteAcre)
      this.conversaoFloat();
      this.valida();

      if (this.camposvalidos) {
        this.mostrarModalResultado();

        this.loading = true;
      if(this.$route.params.ID == 1 && this.$route.params.finalidade !=1){
        console.log(this.$route.params.anexo)
         this.service.postFormAcre(this.$route.params.anexo,this.objetoEnviar).then(
          res => {
            this.reiniciarBool = true;
            this.loading = false;
            console.log(res.data )
            if(typeof res.data == 'number'){
              console.log('vindo')
              let stringResult = "" + res.data 
              this.resultado = this.colocandoMascara(stringResult);
              this.exibirNum = true
              this.resultadoDetalhes = null;
            }
             if(typeof res.data == 'string'){
               let stringResult = "" + res.data 
               this.resultado = stringResult
               this.exibirNum = false
               this.resultadoDetalhes = null;
             }
            if(typeof res.data == 'object' && res.data.detalhes){
              this.resultado = res.data.valor;
              this.resultadoDetalhes = res.data;
              this.exibirNum = true;
            }            
            this.botaoTitulo = "Calcular novamente";
          },
          err => {
            this.loading = false;
            this.resultado =
              "Não foi possível obter o resultado. Verifique sua conexão com a internet";
          }
        );
      }else{
        this.service.postForm(this.objetoEnviar).then(
          res => {
            this.reiniciarBool = true;
            this.loading = false;
            if(typeof res.data == 'number'){
              console.log('vindo')
              let stringResult = "" + res.data;
              console.log(res.data)
              console.log(((6*this.objetoEnviar.valorOperacao)/100));
              /*if(this.$route.params.ID == 21 && this.$route.params.ID == 21 &&((6*this.objetoEnviar.valorOperacao)/100) > res.data ){
                this.exibirResultadoRS = true
              }else{
                this.exibirResultadoRS = false
              }*/
              
              this.resultado = this.colocandoMascara(stringResult);
              this.exibirNum = true
              this.resultadoDetalhes = null;
            }
             if(typeof res.data == 'string'){
               console.log('nao vindo')
               let stringResult = "" + res.data;
               this.resultado = stringResult
               this.exibirNum = false
               this.resultadoDetalhes = null;
             }
            if(typeof res.data == 'object' && res.data.detalhes){
              this.resultado = res.data.valor;
              this.resultadoDetalhes = res.data;
              this.exibirNum = true;
            }  
            this.botaoTitulo = "Calcular novamente";
          },
          err => {
            this.loading = false;
            this.resultado =
              "Não foi possível obter o resultado. Verifique sua conexão com a internet";
          }
        );
      }
        
      } else this.loading = false;
    },

    valida() {
      if (this.objetoEnviar.origem) {
        this.validacao.origem = false;
        this.camposvalidos = 1;

        if (this.objetoEnviar.destino) {
          this.validacao.destino = false;
          this.camposvalidos = 1;

          /* //verifica se o campo de destino e origem são iguais.
                        if(this.objetoEnviar.destino != this.objetoEnviar.origem){
                            this.validacao.destinoOrigem = false;
                            this.camposvalidos = 1; */

          if (parseFloat(this.objetoEnviar.valorOperacao) > 0) {
            this.validacao.valorOperacao = false;
            this.camposvalidos = 1;

            if (parseFloat(this.objetoEnviar.frete) >= 0) {
            
              this.validacao.frete = false;
              this.camposvalidos = 1;

              if (parseFloat(this.objetoEnviar.despesasAcessorias) >= 0) {
                this.validacao.despesasAcessorias = false;
                this.camposvalidos = 1;

                if (parseFloat(this.objetoEnviar.AliquotaInterna) > 0) {
                  
                  this.validacao.AliquotaInterna = false;
                  this.camposvalidos = 1;

                  if (parseFloat(this.objetoEnviar.ReInterna) >= 0) {
                    this.validacao.ReInterna = false;
                    this.camposvalidos = 1;

                    if (
                      parseFloat(this.objetoEnviar.ReInterestadual) >= 0
                    ) {
                      this.validacao.ReInterestadual = false;
                      this.camposvalidos = 1;
                    } else {
                      this.validacao.ReInterestadual = true;
                      this.camposvalidos = 0;
                    }
                  } else {
                    this.validacao.ReInterna = true;
                    this.camposvalidos = 0;
                  }
                } else {
                  this.validacao.AliquotaInterna = true;
                  this.camposvalidos = 0;
                  this.$refs.refaliquotainterna.focus();
                }
              } else {
                this.validacao.despesasAcessorias = true;
                this.camposvalidos = 0;
                this.$refs.refdespesasacessorias.focus();
              }
            } else {
              this.validacao.frete = true;
              this.camposvalidos = 0;
              this.$refs.reffrete.focus();
            }
          } else {
            this.validacao.valorOperacao = true;
            this.camposvalidos = 0;
            this.$refs.refvaloroperacao.focus();
          }

          /* }else{
                            this.validacao.destinoOrigem = true;
                            this.camposvalidos = 0;
                            document.getElementById('ufdestino').focus();
                        } */
        } else {
          this.validacao.destino = true;
          this.camposvalidos = 0;
          document.getElementById("ufdestino").focus();
        }
      } else {
        this.validacao.origem = true;
        this.camposvalidos = 0;
        document.getElementById("uforigem").focus();
      }
    console.log()
   },

    conversaoFloat() {   
       
      this.objetoEnviar.valorOperacao = this.objetoEnviar.valorOperacao.replaceAll(
        ".",
        ""
      ); 
      console.log(this.objetoEnviar.valorOperacao)
      this.objetoEnviar.valorOperacao = this.objetoEnviar.valorOperacao.replaceAll(
        ",",
        "."
      );   
      console.log(this.objetoEnviar.valorOperacao)   
       this.objetoEnviar.valorOperacao = parseFloat(
        this.objetoEnviar.valorOperacao
      );
      console.log(this.objetoEnviar.valorOperacao)   

      this.objetoEnviar.frete = this.objetoEnviar.frete.replace(".", "");
      this.objetoEnviar.frete = this.objetoEnviar.frete.replace(",", ".");
      this.objetoEnviar.frete = parseFloat(this.objetoEnviar.frete);

      this.objetoEnviar.despesasAcessorias = this.objetoEnviar.despesasAcessorias.replace(
        ".",
        ""
      );
      this.objetoEnviar.despesasAcessorias = this.objetoEnviar.despesasAcessorias.replace(
        ",",
        "."
      );
      this.objetoEnviar.despesasAcessorias = parseFloat(
        this.objetoEnviar.despesasAcessorias
      );
      this.objetoEnviar.mva = parseFloat(
        this.objetoEnviar.mva
      );
      this.objetoEnviar.AliquotaInterna = parseFloat(
        this.objetoEnviar.AliquotaInterna
      );
      this.objetoEnviar.ReInterna = parseFloat(
        this.objetoEnviar.ReInterna
      );
      this.objetoEnviar.ReInterestadual = parseFloat(
        this.objetoEnviar.ReInterestadual
      );
    },

    mostrarModalResultado() {
      this.$refs["resultadoID"].show();
    },

    formatarMoeda(valor) {
      if (valor === null || valor === undefined) return 'R$ 0,00';
      return new Intl.NumberFormat('pt-BR', { 
        style: 'currency', 
        currency: 'BRL' 
      }).format(valor);
    },

    formatarPorcentagem(valor) {
      if (valor === null || valor === undefined) return '0,00 %';
      return new Intl.NumberFormat('pt-BR', { 
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      }).format(valor) + ' %';
    },

    mostrarTooltip() {
      this.$refs["valoroperacaotooltip"].show();
    },

    reiniciar() {
      let destino = this.objetoEnviar.destino;
      let importada = this.objetoEnviar.importada;
      // let simplesNacional = this.objetoReceber.simplesNacional;

      this.objetoEnviar = new Aliquota();
      this.objetoReceber = new Aliquota();

      this.objetoEnviar.destino = destino;
      this.objetoReceber.destino = destino;
      this.objetoEnviar.importada = importada;
      this.objetoReceber.importada = importada;

      this.botaoTitulo = "Calcular";
      this.reiniciarBool = false;
      this.tipoDeCalculoPB = false;
      this.valorSN = "0";
    },

    colocandoMascara(string) {
      let indice = 0;

      if (string.includes(".")) {
        indice = string.indexOf(".");
        string = string.substring(0, indice + 3);
      } else {
        string = string + "00";
      }

      let teste = string.substring(indice + 1);

      if (string.includes(".") && teste.length < 2) {
        string = string + "0";
      } else if (string.length <= 2) {
        string = string + "00";
      }

      return string;
    },

    validaAdquirente() {
      if (this.adquirente) {
        this.validacaoAdquirente.adquirente = false;
        if (this.destinatario) {
          this.validacaoAdquirente.destinatario = false;
          if (this.finalidadeAquisicao) {
            this.validacaoAdquirente.finalidadeAquisicao = false;
            if (this.objetoReceber.destino) {
              this.validacaoAdquirente.objetoReceber.destino = false;
              this.validacaoAdquirente.camposvalidos = true;
            } else {
              this.validacaoAdquirente.destinoMercadoria = true;
              this.validacaoAdquirente.camposvalidos = false;
            }
          } else {
            this.validacaoAdquirente.finalidadeAquisicao = true;
          }
        } else {
          this.validacaoAdquirente.destinatario = true;
        }
      } else {
        this.validacaoAdquirente.adquirente = true;
      }
    },

    mostrarModalValidacao() {
      this.validaAdquirente();

      if (this.validacaoAdquirente.camposvalidos) {
      } else if (this.finalidadeAquisicao) {
        this.$refs["validacao-modal"].show();
      }
    }
  },
  computed:{
    alterarNomeProduto(){
        if(this.$route.params.ID == 1 ||this.$route.params.ID == 22 ) {
          return 'da Operação'
        }else{
          return 'dos Produto';
        }  
    },
    alterarMenosParaMaisNoQuadrado(){
        if(this.$route.params.ID == 1 ||this.$route.params.ID == 22 ) {
          return '+'
        }else{
          return '-';
        }  
    },    
  },
  mounted(){
    this.desabilitaIcmAlgumasRegioes();
    if(this.$route.params.anexo == 3){
      this.objetoReceber.AliquotaInterna = 17
      this.porcentagemAliquota.precision = 0;
    }if(this.$route.params.anexo == 5){
      this.objetoReceber.AliquotaInterna = 17
    }
    if(this.$route.params.ID == 24 &&  this.$route.params.finalidade == 2 || this.$route.params.finalidade == 3 && this.$route.params.importado == 2 && this.$route.params.destinatario ==1){
      this.objetoReceber.AliquotaInterna = 12
      this.porcentagemAliquota.precision = 0;
    }
    if (this.objetoReceber.destino == 'DF') {
      this.tipoDeCalculoDF = 1
    }
  }
};
</script>

<style scoped>
.borda {
  border: 1px solid rgb(233, 233, 233);
}
.w100 {
  width: 100%;
}
.erro {
  color: red;
  font-style: oblique;
  display: block;
}
.w-tooltip {
  background-color: rgb(253, 253, 232);
  color: black;
  border: 1px solid rgb(212, 212, 212);
  border-radius: 5px;
  padding: 5px;
  position: absolute;
  width: 250px;
  height: 55px;
  z-index: 1;
  bottom: 50px;
  font-size: 13px;
}
.container {
  max-width: 1168px;
}
.tituloModal {
  font-size: 18px;
  font-weight: bold;
}
.tituloModal2 {
  font-size: 16px;
}
.resultadoInput {
  border: none;
}
.quadrado {
  background-color: black;
  height: 20px;
  width: 20px;
  content: normal;
  display: inline-block;
  position: absolute;
  bottom: -10px;
  left: 45%;
  transform: rotateZ(45deg);
  background-color: rgb(253, 253, 232);
  border-right: 1px solid rgb(212, 212, 212);
  border-bottom: 1px solid rgb(212, 212, 212);
}

.subtitulo {
  font-weight: bold;
  font-size: 14px;
}

.voltar {
  color: rgb(175, 175, 175);
  text-decoration: none;
  font-weight: bold;
}

.disabled {
  background-color: rgb(211, 211, 211);
  margin-left: 15px;
  padding-top: 5px;
  border-radius: 5px;
  color: gray;
}

.loading {
  height: 16px;
  width: 16px;
  font-size: 10px;
}

.select {
  cursor:pointer;
}

.referencia {
  color: rgb(0, 0, 0);
  border-top: 0.8px solid rgb(240, 240, 240);
  display: block;
  margin-top: 20px;
  padding-top: 2px;
}

.desc-fed {
  font-size: 16px;
}

.resultado-detalhado {
  text-align: left;
  padding: 15px;
}

.resultado-detalhado h4 {
  font-size: 18px;
  color: #333;
  border-bottom: 2px solid #e0e0e0;
  padding-bottom: 8px;
}

.info-row {
  padding: 8px 0;
  border-bottom: 1px solid #f0f0f0;
}

.info-row.destaque {
  background-color: #f8f9fa;
  padding: 12px 8px;
  border: 1px solid #dee2e6;
  border-radius: 4px;
  margin-top: 10px;
}

.label-campo {
  font-size: 15px;
  color: #495057;
}

.valor-campo {
  font-size: 15px;
  font-weight: 600;
  color: #212529;
}

</style>


// WEBPACK FOOTER //
// src/components/campoFormulario.vue